var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#9391FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.6718C2.9987 7.60703 7.02895 3.5 12 3.5C16.9706 3.5 21.0009 7.60703 21 12.6718H18.7008C18.7008 8.87615 15.7245 5.7988 12 5.7988C8.27551 5.7988 5.29923 8.87615 5.29923 12.6718H3ZM9.61048 12.8885C10.6216 12.8885 11.4413 12.0688 11.4413 11.0577C11.4413 10.0465 10.6216 9.2269 9.61048 9.2269C8.59938 9.2269 7.77968 10.0465 7.77968 11.0577C7.77968 12.0688 8.59938 12.8885 9.61048 12.8885ZM14.3957 12.8885C15.4068 12.8885 16.2265 12.0688 16.2265 11.0577C16.2265 10.0465 15.4068 9.2269 14.3957 9.2269C13.3846 9.2269 12.5649 10.0465 12.5649 11.0577C12.5649 12.0688 13.3846 12.8885 14.3957 12.8885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/AAVE.7f2bb77311f3cadf09d41463667a83d3.svg";
export { ForwardRef as ReactComponent };